import { FormikProps, getIn } from "formik";
import {
  MetadataModel,
  MetadataTranslationModel,
} from "../../../../models/workflow.model";
import React from "react";
import { FormControl, FormLabel, TextField } from "@mui/material";
import styles from "./Metadata.module.scss";
import { useTranslation } from "react-i18next";

interface Props {
  translation: MetadataTranslationModel;
  propertyName: keyof MetadataTranslationModel;
  label?: string;
  index: number;
  isReadOnly: boolean;
  formik?: FormikProps<MetadataModel> | undefined;
}

const _MetadataTranslation: React.FC<Props> = ({
  translation,
  propertyName,
  label,
  index,
  isReadOnly,
  formik,
}) => {
  const { t } = useTranslation();

  const valuePropName = `translations[${index}].${propertyName}`;
  const error = formik ? getIn(formik.errors, valuePropName) : false;
  const touched = formik ? getIn(formik.touched, valuePropName) : false;

  const multiline = propertyName === "abstract";

  const handleBlur = (event: any) => {
    if (formik) {
      formik.handleBlur(event);
    }
  };

  const handleChange = (event: any) => {
    if (formik) {
      formik.handleChange(event);
    }
  };

  return (
    <div className={styles[`area-${translation.code}-${propertyName}`]}>
      <FormControl fullWidth>
        <FormLabel id={`title-label-${translation.code}`}>
          {t(`translations.${translation.code}.${propertyName}`)}
        </FormLabel>
        <TextField
          id={valuePropName}
          name={valuePropName}
          placeholder={label !== undefined ? t(label)! : t(propertyName)!}
          fullWidth
          multiline={multiline}
          rows={multiline ? 3 : undefined}
          inputProps={{ readOnly: isReadOnly }}
          value={translation[propertyName] || ""}
          onBlur={handleBlur}
          onChange={handleChange}
          helperText={touched && error ? error : ""}
          error={Boolean(touched && error)}
        />
      </FormControl>
    </div>
  );
};

////export default MetadataTranslation;

const MetadataTranslation = React.memo(
  _MetadataTranslation,
  (prevProps, nextProps) => {
    const prevValuePropName = `translations[${prevProps.index}].${prevProps.propertyName}`;
    const nextValuePropName = `translations[${nextProps.index}].${nextProps.propertyName}`;
    return (
      prevProps.translation === nextProps.translation &&
      prevProps.propertyName === nextProps.propertyName &&
      prevProps.translation[prevProps.propertyName] ===
        nextProps.translation[nextProps.propertyName] &&
      getIn(prevProps.formik?.errors, prevValuePropName) ===
        getIn(nextProps.formik?.errors, nextValuePropName) &&
      getIn(prevProps.formik?.touched, prevValuePropName) ===
        getIn(nextProps.formik?.touched, nextValuePropName)
    );
  }
);

export default MetadataTranslation;
